var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0350a5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-27.299 -39.024 54.598 78.047"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.157,34.02c-1.275-1.85-3.408-3.026-5.733-3.026c-2.13,0-4.118,0.985-5.424,2.607   c-1.306-1.622-3.294-2.607-5.423-2.607c-2.325,0-4.457,1.176-5.734,3.026c-1.275-1.85-3.408-3.026-5.733-3.026   c-1.913,0-3.648,0.776-4.908,2.029v-66.474c1.26,1.253,2.995,2.029,4.908,2.029c2.325,0,4.458-1.176,5.733-3.026   c1.277,1.85,3.409,3.026,5.734,3.026c2.129,0,4.117-0.986,5.423-2.607c1.306,1.622,3.294,2.607,5.424,2.607   c2.325,0,4.458-1.176,5.733-3.026c1.277,1.85,3.409,3.026,5.734,3.026c1.913,0,3.647-0.776,4.907-2.028v66.473   c-1.26-1.253-2.994-2.028-4.907-2.028C14.567,30.995,12.435,32.17,11.157,34.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M-20.463-37.524   c0.391,1.615,1.839,2.822,3.573,2.822c1.733,0,3.181-1.207,3.572-2.822h4.323c0.391,1.615,1.839,2.822,3.573,2.822   s3.182-1.207,3.573-2.822h3.701c0.391,1.615,1.839,2.822,3.573,2.822s3.182-1.207,3.573-2.822h4.322   c0.391,1.615,1.839,2.822,3.573,2.822s3.182-1.207,3.573-2.822h5.335v75.047h-5.266c-0.219-1.825-1.759-3.25-3.641-3.25   s-3.423,1.425-3.641,3.25H9.065c-0.219-1.825-1.759-3.25-3.641-3.25s-3.423,1.425-3.641,3.25h-3.564   c-0.219-1.825-1.759-3.25-3.641-3.25s-3.423,1.425-3.641,3.25h-4.186c-0.219-1.825-1.758-3.25-3.641-3.25   c-1.883,0-3.423,1.425-3.641,3.25h-5.267v-75.047H-20.463z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-30.282 -48.056 60.563 94.113"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M16.006,43.056   c-3.233-4.883-8.77-8.108-15.065-8.108s-11.832,3.225-15.065,8.108h-10.584v-88.113h10.584c3.233,4.883,8.77,8.108,15.065,8.108   s11.832-3.224,15.065-8.108H26.59v88.113H16.006z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "7,8",
    x1: 27.781,
    y1: -20.755,
    x2: -27.782,
    y2: -20.755
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-24.712 -42.834 54.356 85.667"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M17.181,40.333h-4.475   c-0.466-2.355-2.539-4.131-5.031-4.131c-2.491,0-4.565,1.776-5.03,4.131h-4.883c-0.466-2.355-2.539-4.131-5.031-4.131   c-2.491,0-4.565,1.776-5.03,4.131h-4.883c-0.466-2.355-2.539-4.131-5.03-4.131v-72.023c2.622,0,4.76-1.974,5.069-4.512h4.806   c0.309,2.539,2.447,4.512,5.069,4.512c2.622,0,4.76-1.974,5.069-4.512h4.806c0.309,2.539,2.447,4.512,5.069,4.512   c2.622,0,4.76-1.974,5.069-4.512h4.398c0.309,2.539,2.447,4.512,5.069,4.512v72.023C19.72,36.202,17.647,37.978,17.181,40.333z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "7,6",
    x1: -22.644,
    y1: -17.395,
    x2: 27.644,
    y2: -17.395
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-23.971 -42.094 47.944 84.188"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 3.521,
    strokeMiterlimit: 10,
    d: "M17.182,40.333h-4.475    c-0.466-2.355-2.539-4.131-5.031-4.131c-2.491,0-4.565,1.776-5.03,4.131h-4.883c-0.466-2.355-2.539-4.131-5.031-4.131    c-2.491,0-4.565,1.776-5.03,4.131h-4.883c-0.466-2.355-2.539-4.131-5.03-4.131v-72.023c2.622,0,4.76-1.974,5.069-4.512h4.806    c0.309,2.539,2.447,4.512,5.069,4.512c2.622,0,4.76-1.974,5.069-4.512h4.806c0.309,2.539,2.447,4.512,5.069,4.512    c2.622,0,4.76-1.974,5.069-4.512h4.398c0.309,2.539,2.447,4.512,5.069,4.512v72.023C19.721,36.202,17.648,37.978,17.182,40.333z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 3.8113,
    strokeMiterlimit: 10,
    points: "5.14,17.02 11.952,13.853    8.431,7.217 7.524,-0.241 0.124,1.057 -7.248,-0.385 -8.301,7.053 -11.951,13.62 -5.201,16.919 -0.084,22.42  "
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "-21.087 -31.266 42.17 72.87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M6.373,39.104h5.21c0-3.87,3.13-7,7-7v-53.87   c-3.87,0-7-3.14-7-7h-5.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M-6.377-28.766h-5.21c0,3.86-3.13,7-7,7v53.87   c3.87,0,7,3.13,7,7h5.21"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 2.373,
    y1: 39.104,
    x2: -2.377,
    y2: 39.104
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 2.373,
    y1: -28.766,
    x2: -2.377,
    y2: -28.766
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    d: "M-9.901-10.118c0-0.994-0.806-1.8-1.8-1.8    s-1.8,0.806-1.8,1.8s0.806,1.8,1.8,1.8S-9.901-9.124-9.901-10.118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    d: "M-2.101-10.118c0-0.994-0.806-1.8-1.8-1.8    s-1.8,0.806-1.8,1.8s0.806,1.8,1.8,1.8S-2.101-9.124-2.101-10.118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    d: "M5.699-10.118c0-0.994-0.806-1.8-1.8-1.8s-1.8,0.806-1.8,1.8    s0.806,1.8,1.8,1.8S5.699-9.124,5.699-10.118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    d: "M13.499-10.118c0-0.994-0.806-1.8-1.8-1.8    s-1.8,0.806-1.8,1.8s0.806,1.8,1.8,1.8S13.499-9.124,13.499-10.118z"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-21.086 -31.266 42.17 72.87"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 42.17,
    height: 72.87,
    x: -21.087,
    y: -31.266,
    transform: "matrix(1 0 0 1 6.996482e-004 -2.671033e-004)",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 9.224,
    y1: 13.75,
    x2: -9.223,
    y2: 13.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#000000",
    d: "M468.792,234.743H-769.006c-2.084,0-3.789-1.705-3.789-3.789V-956.211   c0-2.084,1.705-3.789,3.789-3.789H468.792c2.084,0,3.789,1.705,3.789,3.789V230.954   C472.582,233.038,470.877,234.743,468.792,234.743z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.94,6.101H17.23c-2.536,0-4.599,2.063-4.599,4.598v8.407H9.11c-3.072,0-5.572,2.5-5.572,5.572v1.174    c0,3.073,2.5,5.573,5.572,5.573h3.521v12.419H9.11c-3.072,0-5.572,2.5-5.572,5.572v1.174c0,3.072,2.5,5.572,5.572,5.572h3.521    v12.42H9.11c-3.072,0-5.572,2.5-5.572,5.572v1.174c0,3.072,2.5,5.572,5.572,5.572h3.521v8.406c0,2.535,2.063,4.598,4.599,4.598    h69.71c2.535,0,4.598-2.063,4.598-4.598V10.698C91.538,8.163,89.476,6.101,86.94,6.101z M9.11,29.057    c-1.768,0-3.205-1.438-3.205-3.205v-1.174c0-1.768,1.438-3.205,3.205-3.205h9.41c1.768,0,3.205,1.438,3.205,3.205v1.174    c0,1.768-1.438,3.205-3.205,3.205H9.11z M9.11,53.795c-1.768,0-3.205-1.438-3.205-3.205v-1.174c0-1.768,1.438-3.205,3.205-3.205    h9.41c1.768,0,3.205,1.438,3.205,3.205v1.174c0,1.768-1.438,3.205-3.205,3.205H9.11z M9.11,78.533    c-1.768,0-3.205-1.438-3.205-3.205v-1.174c0-1.768,1.438-3.205,3.205-3.205h9.41c1.768,0,3.205,1.438,3.205,3.205v1.174    c0,1.768-1.438,3.205-3.205,3.205H9.11z M89.171,89.307c0,1.209-1.021,2.23-2.23,2.23H17.23c-1.23,0-2.231-1.001-2.231-2.23V80.9    h3.521c3.072,0,5.572-2.5,5.572-5.572v-1.174c0-3.072-2.5-5.572-5.572-5.572h-3.521v-12.42h3.521c3.072,0,5.572-2.5,5.572-5.572    v-1.174c0-3.072-2.5-5.572-5.572-5.572h-3.521V31.425h3.521c3.072,0,5.572-2.5,5.572-5.573v-1.174c0-3.072-2.5-5.572-5.572-5.572    h-3.521v-8.407c0-1.229,1.001-2.23,2.231-2.23h69.71c1.209,0,2.23,1.021,2.23,2.23V89.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.515,38.8c0-5.858-4.767-10.624-10.625-10.624c-5.857,0-10.623,4.766-10.623,10.624s4.766,10.625,10.623,10.625    C59.748,49.425,64.515,44.658,64.515,38.8z M45.634,38.8c0-4.553,3.703-8.257,8.256-8.257c4.554,0,8.258,3.704,8.258,8.257    c0,4.554-3.704,8.258-8.258,8.258C49.337,47.058,45.634,43.354,45.634,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.72,51.481h-7.659c-6.689,0-12.131,5.442-12.131,12.132v7.033c0,0.652,0.531,1.184,1.185,1.184h29.553    c0.653,0,1.185-0.531,1.185-1.184v-7.033C69.852,56.924,64.409,51.481,57.72,51.481z M67.483,69.463H40.298v-5.85    c0-5.384,4.38-9.764,9.763-9.764h7.659c5.384,0,9.764,4.38,9.764,9.764V69.463z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.44605297cf4d13284c0e3047dce8dccf.svg";
export { ForwardRef as ReactComponent };